import { updateCompanyEmailSettings } from '../Services/companyService';
import { CompanyStatus } from './enums';
import Swal from 'sweetalert2';
import useCompanyStore from '../../../stores/companyStore';

export const updateCompanyEmailSettingsLocal = (
  companyId,
  columnId,
  sendAutomatedEmail,
  emailSubject,
  emailContent,
  fetchCompany
) => {
  updateCompanyEmailSettings(companyId, columnId, sendAutomatedEmail, emailSubject, emailContent)
    .then((response) => {
      fetchCompany();
    })
    .catch((error) => {
      // TODO: handle error
    });
};

export const getParsedEmailSetting = (automatedEmailSendingType, company) => {
  if (!company?.emailSettings) {
    return null;
  }
  if (typeof company?.emailSettings === 'string') {
    try {
      const emailSettings = JSON.parse(company?.emailSettings);
      const affectedEmail = emailSettings?.find((item) => item.Id === automatedEmailSendingType);

      return affectedEmail;
    } catch (error) {
      console.error('Error parsing email settings:', error);
      return null;
    }
  }
};

export const isCompanyVerified = (t) => {
  const company = useCompanyStore.getState().company;

  if (company.companyStatus === CompanyStatus.Verified) {
    return true;
  } else {
    Swal.fire(t('dashboard.VERIFY_MESSAGE'));
    return false;
  }
};
